import styled from "styled-components";

import { Modal } from "antd";
import {
  BUTTON_HEIGHT,
  FONT_SIZE,
  MENU_COLORS,
  TEXT_SCALE_PROPS,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

export const StylesModalContainer = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    .ant-modal-close {
      color: #ffffff;
    }
    .ant-modal-header {
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      border-top-left-radius: 8px;
      background: #1a2a5a;
      .ant-modal-title {
        color: #fff;
      }
    }
  }
`;

export const StylesModalForm = styled.div<TEXT_SCALE_PROPS>`
  width: 100%;
  padding: 0;
  .ant-picker {
    width: 100%;
  }
  .mt-5 {
    margin-top: 30px;
  }
  .mt-6 {
    margin-top: 28px;
  }
  .mt-7 {
    margin-top: 116px;
  }
  @media (max-width: 769px) {
    .mt-5 {
      margin-top: 24px;
    }
    .mt-6 {
      margin-top: 24px;
    }
    .mt-7 {
      margin-top: 24px;
    }
  }
  .form-group {
    position: relative;
    margin-bottom: 24px;
    .label {
      display: flex;
      margin-bottom: 8px;
      justify-content: space-between;
      .text {
        display: flex;
        align-items: center;
        font-size: ${({ text_scale }) =>
          FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
      }
      .btn-label {
        cursor: pointer;
        padding: 2px 4px;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #174a83;
        color: #174a83;
      }
      .btn-label-show {
        background: #1a2a5a;
        cursor: pointer;
        padding: 2px 4px;
        border-radius: 4px;
        color: #fff;
      }
      .required {
        color: red;
        margin-right: 5px;
      }
    }
    .char-count {
      position: absolute;
      right: 0px;
      bottom: -20px;
      color: #bfbfbf;
    }
  }
  .group-button {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    gap: 24px;
    .submit {
      background: #1a2a5a;
      cursor: pointer;
      color: #fff;
      border-radius: 4px;
      padding: 4px 0px;
      text-align: center;
      width: 150px;
      height: 32px;
    }
    .cancel {
      cursor: pointer;
      color: ${MENU_COLORS.TEXT_WHITE};
      background: ${MENU_COLORS.DELETE_ALL};
      border-radius: 4px;
      padding: 4px 0px;
      border: 1px solid ${MENU_COLORS.DELETE_ALL};
      width: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cancel-view {
      cursor: pointer;
      color: #ffffff;
      border-radius: 4px;
      padding: 4px 0px;
      border: 1px solid #174a83;
      background: #174a83;
      width: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ant-form-item-label > label,
  .ant-input,
  .ant-picker-input > input {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  input.ant-input,
  .ant-picker {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
`;
export const StyleMaintenanceNotificationDetail = styled.div<TEXT_SCALE_PROPS>`
  .group-btn {
    justify-content: flex-start !important;
  }
`;
